module.exports = __webpack_public_path__ + "static/media/social_girl.b5e6d0ab.png";